(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["admin/main/includes/modals/_bulk_import_download_modal.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"comet-modal-overlay js-comet-modal-overlay comet-modal-overlay--backdrop\" role=\"dialog\"></div>\n<div class=\"comet-modal js-comet-modal\" role=\"document\" tabindex=\"0\">\n    <div id=bulk-import-download-modal class=\"comet-modal__inner\">\n        <div class=\"comet-modal__header comet-long-form-text\">\n            <h3 class=\"comet-modal__header-content\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "modalHeader"), env.opts.autoescape);
output += "</h3>\n        </div>\n        <div class=\"comet-modal__content comet-long-form-text\">\n            <p>The file that you are about to download contains Personally identifiable information (PII).</p>\n            <p>It should not be shared over insecure channels like email and should be deleted once it is no longer needed.</p>\n        </div>\n        <div class=\"comet-modal__footer\">\n            <div class=\"comet-modal__button-row\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "showCancelButton")) {
output += "\n                    <button class=\"comet-button comet-button--ghost comet-modal__button comet-modal__button--cancel js-comet-modal__close-button\">Cancel</button>\n                ";
;
}
output += "\n                ";
if(runtime.contextOrFrameLookup(context, frame, "showOKButton")) {
output += "\n                    <button class=\"comet-button comet-button--primary comet-modal__button comet-modal__button--confirm\">OK</button>\n                ";
;
}
output += "\n                ";
if(runtime.contextOrFrameLookup(context, frame, "downloadUrl")) {
output += "\n                    <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "downloadUrl"), env.opts.autoescape);
output += "\" class=\"comet-button comet-button--primary comet-modal__button\">Download</a>\n                ";
;
}
output += "\n            </div>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/admin/templates/includes/modals/_bulk_import_download_modal", function(){});

